import React from 'react';
import CustomerList from '../../components/Customers/CustomerList';

const CustomersPage: React.FC = () => {
    return (
        <div className="customers-page">
            <CustomerList />
        </div>
    );
};

export default CustomersPage; 